/* ==================================================
  カスタム:関連商品の非同期読み込み

  テーマ本体の theme.js は section_id=product-recommendations を
  ハードコードしており、カスタムセクションを指定できない。
  そのため取得処理をこちらに持つ（jQuery非依存）
===================================================*/

(() => {
  const SELECTOR = '[data-c_product-recommendations]';

  const rootUrl = () => {
    const root = window.Shopify && window.Shopify.routes && window.Shopify.routes.root;
    return root || '/';
  };

  /* ------------------------------
    取得と差し込み
  ------------------------------*/

  const load = async (container) => {
    const productId = container.dataset.productId;
    const sectionId = container.dataset.sectionId;
    const limit = container.dataset.limit || '4';

    if (!productId || !sectionId) return;

    /*  二重取得の防止  */
    if (container.dataset.c_loaded === 'true') return;
    container.dataset.c_loaded = 'true';

    const url = `${rootUrl()}recommendations/products?section_id=${encodeURIComponent(
      sectionId
    )}&product_id=${encodeURIComponent(productId)}&limit=${encodeURIComponent(limit)}`;

    try {
      const response = await fetch(url);

      if (!response.ok) {
        throw new Error(`Recommendations request failed: ${response.status}`);
      }

      const text = await response.text();
      const doc = new DOMParser().parseFromString(text, 'text/html');
      const rendered = doc.getElementById(`shopify-section-${sectionId}`) || doc.body;
      const markup = rendered.innerHTML.trim();

      /*  関連商品が0件のときは空文字が返る。その場合は何も描画しない  */
      if (markup) {
        container.innerHTML = markup;
      }
    } catch (error) {
      console.error('[c_product-recommendations]', error);
    }
  };

  const init = (scope) => {
    scope.querySelectorAll(SELECTOR).forEach(load);
  };

  /* ------------------------------
    初期化
  ------------------------------*/

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(document));
  } else {
    init(document);
  }

  /*  テーマエディタでセクションを操作したとき  */
  document.addEventListener('shopify:section:load', (event) => {
    init(event.target);
  });
})();
